import RequestDetail from './RequestDetail.jsx';

export {RequestDetail}



// WEBPACK FOOTER //
// ./components/requests/index.js